$(document).ready(function () { 
  
      if($('.img_text_slide_random').length>0){ 
        // Step 1: Randomize slides
        const $slider = $('.img_text_slide_random');
        const $slides = $slider.find('.slideshow__slide.slide_show_inner');
      /*
        if ($slides.length) {
          const shuffledSlides = $slides.sort(function () {
            return 0.5 - Math.random();
          });
      
          $slider.trigger('destroy.owl.carousel'); // Just in case it's already initialized
          $slider.empty(); // Remove existing slides
      
          // Append shuffled slides
          shuffledSlides.each(function () {
            $slider.append($(this));
          });
        }
      */
        // Step 2: Initialize Owl Carousel
        const randSlider = $slider.owlCarousel({
          items: 1,
          loop: true,
          autoplay: true,
          animateOut: 'fadeOut',
          nav: false,
          dots: false,
          onInitialized: updateSlideInfo,
          onChanged: updateSlideInfo
        });
      
        // Step 3: Cache navigation and counter elements
      
        // Step 4: Update counters and button states
        function updateSlideInfo(event) {
          
              let rend_current_index = $('.image_with_text_slideshow .slider-counter--current');
              let rend_total_index = $('.image_with_text_slideshow .slider-counter--total'); 
          let currentIndex = event.item.index + 1;
          const totalItems = event.item.count;
          if(currentIndex > totalItems ){
            currentIndex = Number(currentIndex) - Number(totalItems);
          }
          rend_current_index.text(currentIndex);
          rend_total_index.text(totalItems);
       
        }
      
       
    }



  
    var $stickyElement = $('.template-collection #ProductGridContainer');

    if ($stickyElement.length) { // Check if stickyElement exists
        var $itemToSticky = $('.template-collection #main-collection-filters');
        var stickyElementOffset = $stickyElement.offset().top - 50;

        function handleScroll() {
            var scrollPosition = $(window).scrollTop();
            var $headerSticky = $('.shopify-section-header-sticky');

            if (scrollPosition >= stickyElementOffset) {
                if (!$headerSticky.hasClass('shopify-section-header-hidden')) {
                    $itemToSticky.addClass('sticky_top');
                } else {
                    $itemToSticky.removeClass('sticky_top');
                }
            } else {
                $itemToSticky.removeClass('sticky_top');
            }
        }

        $(window).on('scroll', handleScroll); // Call handleScroll when user scrolls
    }
});


$(document).ready(function(){
  $('.pickyou_Banners').each(function() {
    var desktopColumns = $(this).attr('desktop-column-count');
    var mobileColumns =  $(this).attr('mobile-column-count');
    var slideCenter =  $(this).attr('slide-center');
    desktopColumns = desktopColumns ? parseFloat(desktopColumns) : 1.5;
    mobileColumns = mobileColumns ? parseFloat(mobileColumns) : 1;

    $(this).addClass('owl-carousel');

    $(this).owlCarousel({
          center: true,
          items: mobileColumns,
          nav: true,
          dots: true,
          loop: true,
          margin: 10,
          responsive: {
              600: {
                  items: desktopColumns,
                  center: slideCenter
              }
          }
      });
    console.log('desktop - ' + (desktopColumns * 5));
    console.log('mobile - ' + (mobileColumns * 5));
  });



        var cards_container = $(".rondom_grid");
        var cards = $(".rondom_grid .collection-list .collection-list__item");
        var $cardsBox = $(".rondom_grid .collection-list");

        if(cards.length > 2){
                  for(var i = 0; i < cards.length; i++){
                      var target = Math.floor(Math.random() * cards.length -1) + 1;
                      var target2 = Math.floor(Math.random() * cards.length -1) +1;

                    //console.log(`${target} and ${target2}`);

                      cards.eq(target).before(cards.eq(target2));
                  }
            var randcards = $(".rondom_grid .collection-list .collection-list__item");

            $cardsBox.empty();



            var itemsPerCard = 50;
            //var remainingItems = randcards.length % itemsPerCard;
            var numCards = cards_container.length;


            for (var i = 0; i < numCards; i++) {
              var startIndex = i * itemsPerCard;
              var endIndex = startIndex + itemsPerCard;
              var cardItems = randcards.slice(startIndex, endIndex);
              cards_container.eq(i).find(".collection-list").html(cardItems);

              //console.log(`${startIndex} to ${endIndex}`);
            }
        }



      $(document).on('dragend mouseup touchend','.price_slider_container', function() {
        $(this).trigger('click');
      });


    $(document).on('click', 'facet-remove a', function() {
        const urlParams = new URLSearchParams($(this).attr('href')); // Create a URLSearchParams object from the href attribute
        if (urlParams.has('filter.v.availability')) {
            $('#inventoryFilterDesktop').prop('checked', true);
        } else {
            $('#inventoryFilterDesktop').prop('checked', false);
        }
    });
});

var ListOrderManager = {
  applyRandomOrder: function() {
    var lists = document.querySelectorAll('.random_order ul.collection-list');

    if (lists.length > 0) {
      lists.forEach(function(list) {
        var listItems = list.querySelectorAll('li');
        var totalItems = listItems.length;

        // Generate an array of numbers from 0 to (totalItems - 1)
        var orderArray = Array.from(Array(totalItems).keys());

        // Shuffle the array to randomize the order
        for (let i = orderArray.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [orderArray[i], orderArray[j]] = [orderArray[j], orderArray[i]];
        }

        // Apply the shuffled order to the list items
        listItems.forEach(function(item, index) {
          item.style.order = orderArray[index]; // Assign unique random order
          //console.log('Added order:', orderArray[index]);
        });
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
   ListOrderManager.applyRandomOrder();
});





// image change rendom

const HoverEffectManager = {
    hoverEffects: document.querySelectorAll(".collection-301771358357 .media--hover-effect"),
    duration: 3000, // 2 seconds for class to be applied and removed
    delay: 100, // 100 ms stagger between items
    batchSize: 10, // Reset every 10 items
    intervalId: null,

    applyHoverEffect() {
        this.hoverEffects.forEach((element, index) => {
            setTimeout(() => {
                this.toggleHoverEffect(element); // Start toggle effect for each element
            }, (index % this.batchSize) * this.delay); // Staggered delay for each element
        });
    },

    toggleHoverEffect(element) {
        // Create a repeating effect for each element
        setInterval(() => {
            element.classList.add("apply_hover");
            setTimeout(() => {
                element.classList.remove("apply_hover");
            }, this.duration); // Remove class after 2 seconds
        }, this.duration * 2); // Repeat every 4 seconds (2 seconds add + 2 seconds remove)
    },

    start() {
        if (this.hoverEffects.length === 0) return; // Only start if elements are found
        this.applyHoverEffect(); // Start the effect immediately
    },

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },

    init() {
        if (!this.initialized) { // Ensure initialization happens only once
            window.addEventListener("load", () => this.start()); // Start after page fully loads
            this.initialized = true;
        }
    }
};

// Initialize the hover effect manager
// HoverEffectManager.init();





$(document).ready(function () {
    const autoplayTimeout = 5000;  

    const slider = $('.image_with_text_slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: autoplayTimeout,
        animateOut: 'fadeOut',
        nav: false,
        dots: true,
        onChanged: function (event) {
            if ($(event.target).find('.owl-dot').length > 0) {
                updatePrevNextClasses(event); // Call the function if dots exist
            }
        }
    });

    function updatePrevNextClasses(event) {
        const $dots = $(event.target).find('.owl-dot'); // All dots
        const activeIndex = event.item.index - event.relatedTarget._clones.length / 2; // Adjust for clones
        const totalItems = event.item.count; // Total number of items

        // Normalize the index for looping
        const normalizedIndex = (activeIndex + totalItems) % totalItems;

        // Remove previous 'prev-dot' and 'next-dot' classes from all dots
        $dots.removeClass('prev-dot next-dot');

        // Add 'prev-dot' and 'next-dot' classes
        $dots.each(function (index) {
            if (index < normalizedIndex) {
                $(this).addClass('prev-dot');
            } else if (index > normalizedIndex) {
                $(this).addClass('next-dot');
            }
        });

        // Ensure the active dot itself does not have 'prev-dot' or 'next-dot'
        $dots.eq(normalizedIndex).removeClass('prev-dot next-dot');

        // Handle wrap-around for looping carousels
        if (normalizedIndex === 0 && totalItems > 1) {
            $dots.last().addClass('prev-dot');
        }
        if (normalizedIndex === totalItems - 1 && totalItems > 1) {
            $dots.first().addClass('next-dot');
        }
    }
});








// Check if `.banner_slider` exists

$(document).ready(function () {
  

  
  if ($('.slideshow_new.swiper-container').length > 0) {  
     let isWaitingForSecondScroll = 0;
      const swiper = new Swiper('.slideshow_new.swiper-container', {
        direction: 'vertical',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: false,
        mousewheel: {
          forceToAxis: true, 
          releaseOnEdges: true
        },
        touchReleaseOnEdges: true, // Try this instead
      });

 
  }
  
  if ($('.banner_slider.owl-carousel').length > 0) {
    $('.banner_slider.owl-carousel').each(function () {
      const $slider = $(this);

      // Get data attributes
      const bannerCount = parseInt($slider.data('banner-count')) || 0;
      const productCount = parseInt($slider.data('product-count')) || 0;
      const collectionCount = parseInt($slider.data('collection-count')) || 0;
      const itemCenter = Boolean(Number($slider.data('slide-center')) || 0); 
      const itemLoop = Boolean(Number($slider.data('slide-loop')) || 0); 
      const itemsDesktop = parseInt($slider.data('columns-desktop')) || 3;
      const itemsTablet = parseInt($slider.data('columns-tablet')) || 2;
      const itemsMobile = parseInt($slider.data('columns-mobile')) || 1; 
      const autoplayTimeout = parseInt($slider.data('autoplay-timeout')) || 3000;
 
      // Determine itemsToShow based on block types
      let itemsToShow = 1; // Default
      if (bannerCount > 0) {
        itemsToShow = 1; // Full width for banners
      } else if (productCount > 0) {
        itemsToShow = Math.max(itemsDesktop, itemsTablet, itemsMobile); // Use responsive settings
      } else if (collectionCount > 0) {
        itemsToShow = 2; // Default to 2 items for collections
      }

      // Initialize Owl Carousel
      $slider.owlCarousel({
        loop: itemLoop,
        margin: 10,
        nav: false,
        dot: false,
        autoplay: false,
        center: itemCenter, 
        autoplayTimeout: autoplayTimeout,
        responsive: {
          0: { items: itemsMobile },
          600: { items: itemsTablet },
          1000: { items: itemsDesktop }
        }
      });

      // Add navigation functionality for each slider
      const $nav = $slider.closest(".banner_slider_section").find(".nav_arrow");
      if ($nav.length) {
        const $prevArrow = $nav.find(".s_arrow_left");
        const $nextArrow = $nav.find(".s_arrow_right");

        // Update arrow states
        function updateArrows() {
          setTimeout(function(){
            
              const currentIndex = $slider.find('.owl-item.active').first().index();
              const totalItems = $slider.find('.owl-item').length;
    
              if (currentIndex > 0 || itemLoop) {
                $prevArrow.addClass('active');
                console.log(currentIndex); 
              } else {
                $prevArrow.removeClass('active');
              }
    
              if (currentIndex + $slider.find('.owl-item.active').length < totalItems || itemLoop) {
                $nextArrow.addClass('active');
              } else {
                $nextArrow.removeClass('active');
              }

          }, 100);
        }

        // Initial state
        updateArrows();

        // Listen to events to update arrows
        $slider.on('changed.owl.carousel', function () {
          updateArrows();
        });

        // Navigation click events
        $prevArrow.on("click", function () {
          $slider.trigger("prev.owl.carousel");
        });

        $nextArrow.on("click", function () {
          $slider.trigger("next.owl.carousel");
        });
      }
    });
  }
});

/* new script */

// .nav-buttonの高さを指定
function setNavButtonPosition() {
  const cardContent = document.querySelector('.product-link .card__content');
  if (!cardContent) return;
  
  const halfHeight = cardContent.offsetHeight / 2;
  
  const style = document.createElement('style');
  style.textContent = `.nav-button { top: ${halfHeight}px!important; }`;
  document.head.appendChild(style);
}
setNavButtonPosition();

// .nav-buttonにクリックイベントを付与
function initializeProductImageBehavior() {
  // すべての製品リンクに対して処理を実行
  document.querySelectorAll('a.product-link').forEach(link => {
    // 既に初期化されている場合はスキップ
    if (link.hasAttribute('data-initialized')) return;
    
    // 画像を取得（両方の構造に対応）
    const images = link.querySelectorAll('.media img, .rv_image_area img');
    if (images.length < 2) return;
    
    const firstImage = images[0];
    const secondImage = images[1];
    
    // 初期状態を設定
    firstImage.style.opacity = '1';
    secondImage.style.opacity = '0';
    let isFirstImageVisible = true;
    
    // ナビゲーションボタンを取得（Liquidで追加済みと想定）
    const prevButton = link.querySelector('.nav-button.prev');
    const nextButton = link.querySelector('.nav-button.next');
    
    if (!prevButton || !nextButton) return;
    
    // active クラスの初期設定
    prevButton.classList.remove('active');
    nextButton.classList.add('active');
    
    // タッチ操作用の変数
    let touchStartX = 0;
    let touchEndX = 0;
    
    // 画像切り替え関数
    const showFirstImage = () => {
      firstImage.style.opacity = '1';
      secondImage.style.opacity = '0';
      isFirstImageVisible = true;
      prevButton.classList.remove('active');
      nextButton.classList.add('active');
    };
    
    const showSecondImage = () => {
      firstImage.style.opacity = '0';
      secondImage.style.opacity = '1';
      isFirstImageVisible = false;
      nextButton.classList.remove('active');
      prevButton.classList.add('active');
      
      // // GAイベントトラッキング
      // const shopifySection = link.closest('.shopify-section');
      // let shopifySectionTitle;

      // // 同じカテゴリのアイテムの場合
      // if (shopifySection.querySelector('.page-width.section-category-product__container')) {
      //   shopifySectionTitle = "同じカテゴリのアイテム";
      // }
      // // 同じ出品者のアイテムの場合
      // else if (shopifySection.querySelector('.page-width.section-picker-product__container')) {
      //   shopifySectionTitle = "同じ出品者のアイテム";
      // }
      // // それ以外の場合
      // else {
      //   const headerTitle = shopifySection.querySelector('h2.section-header__title');
      //   shopifySectionTitle = headerTitle ? headerTitle.textContent.trim() : "不明なセクション";
      // }

      // window.dataLayer = window.dataLayer || [];
      // dataLayer.push({
      //   'event': 'second_img_impression',
      //   'second_img_impression_category': shopifySectionTitle
      // });
    };
    
    // ボタンクリックハンドラー
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showSecondImage();
      return false; // リンクのナビゲーションを防止
    });
    
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showFirstImage();
      return false; // リンクのナビゲーションを防止
    });
    
    // タッチイベントハンドラー
    link.addEventListener('touchstart', (e) => {

      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    link.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].clientX;
      const swipeDistance = touchEndX - touchStartX;
      
      if (Math.abs(swipeDistance) > 50) {
        if (swipeDistance > 0 && !isFirstImageVisible) {
          showFirstImage();
        } else if (swipeDistance < 0 && isFirstImageVisible) {
          showSecondImage();
        }
      }
    }, { passive: true });
    
    // 初期化済みとマーク
    link.setAttribute('data-initialized', 'true');
  });
}



const observeForProductGrid = () => {
  // 製品コンテナの要素を取得
  const productGridContainer = document.querySelector('.product-grid-container');
  
  // 製品コンテナが存在しない場合は処理を終了
  if (!productGridContainer) {
    return;
  }
  
  const observer = new MutationObserver(() => {
    // 最初の製品リンクを探す
    const firstProductLink = document.querySelector('.product-link');
    
    // リンクが存在するが、初期化されていない場合に初期化を実行
    if (firstProductLink && !firstProductLink.hasAttribute('data-initialized')) {
      initializeProductImageBehavior();
    }
  });
  
  // 製品コンテナが存在する場合のみ監視を開始
  observer.observe(productGridContainer, {
    childList: true,
    subtree: true
  });
};

const observeForRecentViewed = () => {
  // 監視対象を最初に定義し、存在チェックを行う
  const targetElement = document.querySelector('#pickyou-recently-viewed-products-area');
  if (!targetElement) {
    return; // 要素がない場合は処理を終了
  }

  const observer = new MutationObserver(() => {
    const uninitializedLinks = document.querySelectorAll('#pickyou-recently-viewed-products .product-link:not([data-initialized])');
    
    if (uninitializedLinks.length > 0) {

      
      const initializeInterval = setInterval(() => {
        initializeProductImageBehavior();
        
        const remainingLinks = document.querySelectorAll('#pickyou-recently-viewed-products .product-link:not([data-initialized])');
        if (remainingLinks.length === 0) {
          clearInterval(initializeInterval);
        }
      }, 1000);
    }
  });

  // 存在確認済みの要素を監視開始
  observer.observe(targetElement, {
    childList: true,
    subtree: true
  });

};

// 初期セットアップ
initializeProductImageBehavior();
observeForRecentViewed();
observeForProductGrid();

const displayPointInfo = (pointValue) => {
  const loginAlertStyle = userProps.user_id !== null ? ' style="display: none;"' : '';
  const newContent = `
    <div class="optx-mrpoint-productaward-point-value">
      <span class="optx-point-value">${pointValue}</span>
      <span class="optx-point-string">pt</span>
      <span class="optx-point-striing">獲得</span>
    </div>
    <div class="optx-mrpoint-login-alert"${loginAlertStyle}>
      <div style="display: flex; align-items: start; gap: 6px;">
        <div style="padding-top: 3px;"><img src="https://assets.optimize-next.com/17axabb7.png" width="18px" height="18px"></div>
        <div>
          ポイントを獲得するためには<a href="/account/login">ログイン</a>または<a href="/account/register">アカウントを作成</a>してください
        </div>
      </div>
    </div>
    <style>
      .mrpoint-product__award-point {
        display: none;
      }
      product-info > div[role="status"], 
      product-info .price__container, 
      .optx-mrpoint-productaward-point-value {
        margin-bottom: 0!important;
      }
      .optx-mrpoint-productaward-point-value {
        margin-top: -5px!important;
        font-weight: bold;
      }
      .optx-point-value {
        font-size: 18px;
        color: #ed293e;
      }
      .optx-point-striing {
        font-size: 12px;
      }
      .optx-mrpoint-login-alert {
        font-size: 12px;
        margin-top: -5px!important;
      }
      .optx-mrpoint-login-alert a,
      .optx-mrpoint-login-alert a:visited {
        color: #000000!important;
        font-weight: bold;
        text-decoration: underline;
      }
      .optx-mrpoint-login-alert > img {
        width: 12px;
        height: 12px;
        margin-top: -5px!important;
      }
      #app-embed-container-231467 {
        display: none!important;
      }
    </style>
  `;
  const targetElement = document.querySelector('.product__info-container [role="status"]');
  if (targetElement) {
    targetElement.insertAdjacentHTML('afterend', newContent);
  }
};
const pointElement = document.querySelector('.mrpoint-product__award-point-value.js-award-point-value');
if (pointElement) {
  // テキストが既に存在する場合
  if (pointElement.textContent.trim()) {
    displayPointInfo(pointElement.textContent);
  }
  
  // テキストの変更を監視
  const observer = new MutationObserver((mutations, obs) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        const updatedText = pointElement.textContent.trim();
        if (updatedText) {
          obs.disconnect();
          displayPointInfo(updatedText);
        }
      }
    });
  });
  // テキストノードと子要素の両方を監視
  observer.observe(pointElement, {
    characterData: true,
    childList: true,
    subtree: true
  });
}
// NEW END 


window.addEventListener('load', () => {
	setTimeout(() => {
      $('.biggo-relative-product-list .item-price').each(function() {
          const text = $(this).text();
          $(this).text(text.replace('￥', '¥'));
      });
    }, 1000);
});

// iOS 18.4.1より古いバージョンを検出し、特定のCSSを追加する関数
function addCSSForOlderIOS() {
  // iOSデバイスかどうかをチェック
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // iOS以外の場合は何もしない
  if (!isIOS) return;
  
  // iOSバージョンを抽出
  let match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (!match) return;
  
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3] || 0, 10);
  
  // iOS 18.4.1より古いバージョンかチェック
  if (major < 18 || (major === 18 && (minor < 4 || (minor === 4 && patch < 1)))) {
    // スタイル要素を作成
    const style = document.createElement('style');
    
    // 要求されたCSSプロパティを追加
    style.textContent = `
      .product-link .nav-button svg,
      .multi_collection .nav-button svg,
      .product-grid .nav-button svg {
        transform: scale(2.5);
      }
    `;
    
    // スタイルをドキュメントのヘッドに追加
    document.head.appendChild(style);
    console.log('古いiOSバージョン用のCSSを適用しました');
  }
}

// DOMの読み込み完了時に実行
document.addEventListener('DOMContentLoaded', addCSSForOlderIOS);